var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction"},[_c('h1',[_vm._v("I Ching")]),_c('p',[_vm._v("Find a question to ask the oracle.")]),_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":{name: 'consult'}}},[_vm._v("Begin")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }